<template>
  <div class="complaint-page">
    <p>订单申诉2.0版本</p>
    <div class="actions-bar">
      <el-input placeholder="请输入订单ID" clearable v-model="id">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-input placeholder="userId" clearable v-model="userId">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>

      <el-select v-model="status" placeholder="请选择审核状态">
        <el-option label="全部" value=""></el-option>
        <el-option label="起诉发起" value="1"></el-option>
        <el-option label="起诉审核中" value="2"></el-option>
        <el-option label="起诉审核不通过" value="3"></el-option>
        <el-option label="起诉成立" value="4"></el-option>
        <el-option label="被诉应诉" value="5"></el-option>
        <el-option label="诉审核中" value="6"></el-option>
        <el-option label="被诉审核不通过" value="7"></el-option>
        <el-option label="被诉审核通过" value="8"></el-option>
        <el-option label="结束" value="9"></el-option>
      </el-select>

      <el-select v-model="valid" style="margin-left:12px" placeholder="是否有效">
        <el-option label="全部" value=""></el-option>
        <el-option label="有效" value="true"></el-option>
        <el-option label="无效" value="false"></el-option>
      </el-select>
      <el-button type="primary" class="searchBtn" @click="handleSearch">搜索</el-button>
    </div>
    <el-table :data="allegeList" style="width: 100%">
      <el-table-column prop="id" label="ID" width="180"> </el-table-column>
      <el-table-column prop="orderId" label="订单ID" width="180"> </el-table-column>
      <el-table-column prop="advertisingId" label="广告ID" width="180"> </el-table-column>
      <el-table-column prop="allegeUserId" label="起诉方ID" width="180"> </el-table-column>
      <el-table-column prop="oppositeUserId" label="应诉方ID" width="180"> </el-table-column>
      <el-table-column prop="" label="状态" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">起诉发起</span>
          <span v-else-if="scope.row.status == 2">起诉审核中</span>
          <span v-else-if="scope.row.status == 3">起诉审核不通过</span>
          <span v-else-if="scope.row.status == 4">起诉成立</span>
          <span v-else-if="scope.row.status == 5">被诉应诉</span>
          <span v-else-if="scope.row.status == 6">应诉审核中</span>
          <span v-else-if="scope.row.status == 7">被诉审核不通过</span>
          <span v-else-if="scope.row.status == 8">被诉审核通过</span>
          <span v-else>结束</span>
        </template>
      </el-table-column>
      <el-table-column prop="coinType" label="申诉结果" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.result == 1">申诉执行撤销订单</span>
          <span v-if="scope.row.result == 2">申诉执行完成订单</span>
          <span v-if="scope.row.result == 3">根据实际情况决定</span>
          <span v-if="scope.row.result == 4">申诉执行退款</span>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="winUserId" label="胜诉方ID" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.winUserId }}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="valid" label="是否有效" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.valid">有效</span>
          <span v-else>无效</span>
        </template>
      </el-table-column>

      <el-table-column prop="" label="创建时间" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="更新时间" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="currencyCoin" label="type" width="130">
        <template slot-scope="scope">
          <span>{{ scope.row.type }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="" label="方向" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.direction == 'B'">购买</span>
          <span v-else>出售</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="170">
        <template slot-scope="scope">
          <span v-if="!scope.row.alleged">
            <el-button
              @click="allegeDetail(scope.row.id)"
              v-if="scope.row.status == 2 || scope.row.status == 6"
              type="text"
              size="small"
              >材料审核</el-button
            >
            <el-button
              @click="allegeDetail(scope.row.id)"
              v-else-if="scope.row.status == 8 || scope.row.status == 4 || scope.row.status == 7"
              type="text"
              size="small"
              >审核判定</el-button
            >

            <el-button @click="allegeDetail(scope.row.id)" v-else type="text" size="small">申诉明细</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next, total, jumper"
      @current-change="pageChange"
      @size-change="sizeChange"
      :current-page="page"
      :page-size="size"
      :total="allegeListTotal"
      prev-text="上一页"
      next-text="下一页"
    >
    </el-pagination>
    <el-dialog
      title="审核材料详情"
      :visible.sync="appealDetailVisible"
      @close="appealDetailVisible = false"
      :before-close="closAappealDialog"
      width="60%"
      center
    >
      <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" class="applicationForm">
        <div v-for="(item, index) in ruleForm.operationRecords" :key="item.id">
          <p class="fromCaptionTitle">
            <span v-if="item.userId == ruleForm.allege.allegeUserId" style="color:red">发起方</span>
            <span v-else-if="item.userId == ruleForm.allege.oppositeUserId" style="color:orange">被起诉方</span>
            <span v-else style="color:#838689">客服</span>
            <span style="margin-left:15px;">{{ item.createTime | moment }}</span>
          </p>
          <el-form-item label="申诉说明：" :index="index" prop="result">
            <!-- <el-input type="textarea" v-model="item.description" disabled="disabled"></el-input> -->
            <div class="descriptionBox">
              <span> {{ item.description }}</span>
            </div>
            <div class="descriptionImgs">
              <div class="imgs" v-for="(imgSrc, i) in JSON.parse(item.fileUrls)" :key="imgSrc + i">
                <img @click="handlePictureCardPreview(imgSrc)" :src="imgSrc" alt="" />
              </div>
            </div>
          </el-form-item>
          <div class="fenGeXian"></div>
        </div>

        <fieldset>
          <legend>客服说明：</legend>
          <el-form-item label="是否通过审核" v-if="ruleForm.allege.status == 2 || ruleForm.allege.status == 6">
            <el-select v-model="auditForm.isValid" placeholder="是否通过审核">
              <el-option label="通过审核" value="true"></el-option>
              <el-option label="未通过审核" value="false"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="选择胜诉方"
            v-if="ruleForm.allege.status == 8 || ruleForm.allege.status == 4 || ruleForm.allege.status == 7"
          >
            <el-select v-model="judgeFrom.winUserId" placeholder="选择胜诉方">
              <el-option label="申诉方胜" :value="ruleForm.allege.allegeUserId"></el-option>
              <el-option label="被申诉方胜" :value="ruleForm.allege.oppositeUserId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="判定类型"
            v-if="ruleForm.allege.status == 8 || ruleForm.allege.status == 4 || ruleForm.allege.status == 7"
          >
            <el-select v-model="judgeFrom.resultCode" placeholder="请选择类型">
              <el-option label="取消订单" v-if="ruleForm.allege.orderStatus==3" value="1"></el-option>
              <el-option label="完成订单" v-if="ruleForm.allege.orderStatus ==3" value="2"></el-option>
              <el-option label="结束申诉" value="3"></el-option>
              <el-option label="结束申诉(卖方退款)" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客服备注" prop="name">
            <el-input
              v-if="ruleForm.allege.status == 8 || ruleForm.allege.status == 4 || ruleForm.allege.status == 7"
              v-model.trim="judgeFrom.description"
              type="textarea"
              placeholder="请添加描述,描述内容不超过200字"
              maxlength="200"
              show-word-limit
            ></el-input>
            <el-input
              v-else
              v-model.trim="auditForm.description"
              placeholder="请添加描述,描述内容不超过200字"
              maxlength="200"
              show-word-limit
              style="min-height:60px;"
              type="textarea"
            >
            </el-input>
          </el-form-item>
          <div class="commintBox" v-if="ruleForm.allege.status">
            <el-button type="success" @click="auditBtn" v-if="ruleForm.allege.status == 2 || ruleForm.allege.status == 6"
              >材料审核</el-button
            >
            <el-button
              type="primary"
              @click="judgeBtn"
              v-if="ruleForm.allege.status == 8 || ruleForm.allege.status == 4 || ruleForm.allege.status == 7"
              plain
              >审核判定</el-button
            >
          </div>
        </fieldset>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="merchantDetailVisible = false">取 消</el-button> -->
        <el-button type="info" @click="closAappealDialog">返 回</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogImgVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import api from "../../api";
export default {
  name: "merchantRecordList",
  data() {
    return {
      appealDetailVisible: false,
      valid: "true",
      ruleForm: {
        allege: {
          status: 0
        }
      },
      page: 1,
      size: 11,
      userId: "",
      status: "",
      id: "",
      // MerchantRecordList:{}
      auditlVisible: false,
      auditForm: {
        id: "",
        description: "",
        isValid: ""
      },
      judgeFrom: {
        id: "",
        winUserId: "",
        resultCode: "",
        description: ""
      },
      operationName: "XX",
      dialogImgVisible: false,
      dialogImageUrl: "",

      addInfo: ""
    };
  },
  computed: {
    ...mapState("otc", ["allegeListTotal", "allegeList"])
  },
  components: {},

  watch: {
    //监听广告配置的变化
    // auditForm: {
    //     handler: function (newAuditForm, oldConfig) {
    //         if(newAuditForm.isValid){
    //           this.addInfo="材料通过审核  备注："
    //             newAuditForm.description=this.addInfo+ newAuditForm.description;
    //         }else{
    //            this.addInfo="材料未通过审核  备注："
    //              newAuditForm.description=this.addInfo+ newAuditForm.description;
    //         }
    //     },
    //     deep: true
    // },
  },
  methods: {
    ...mapActions("otc", ["getOtcAllegeList"]),
    closAappealDialog() {
      (this.auditForm = {
        id: "",
        description: "",
        isValid: ""
      }),
        (this.judgeFrom = {
          id: "",
          winUserId: "",
          resultCode: "",
          description: ""
        });
      this.appealDetailVisible = false;
    },
    //材料审核下拉选择
    materialReview(e) {
      let that = this;
      if (e == "true") {
        this.addInfo = "材料通过审核  备注：";
      } else {
        this.addInfo = "材料未通过审核  备注：";
      }
    },

    //查看大图
    handlePictureCardPreview(imgUrl) {
      this.dialogImageUrl = imgUrl;
      this.dialogImgVisible = true;
    },
    //申诉审核判定
    judgeBtn() {
      let that = this;
      this.judgeFrom.id = this.judgeFrom.id.toString();

      if (!this.judgeFrom.description) {
        const h = that.$createElement;
        that.$notify({
          title: "",
          message: h("i", { style: "color: red" }, "请填写描述")
          // duration: 0
        });
        return false;
      }
      this.judgeFrom.description = this.judgeFrom.description.toString();

      let data = this.judgeFrom;

      api.isAuditAllege(data).then(res => {
        if (!res.code) {
          that.$message({
            message: res.msg,
            type: "success"
          });
          that.appealDetailVisible = false;
          that.handleSearch();
        } else {
          that.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },

    auditBtn() {
      let that = this;
      this.auditForm.id = this.auditForm.id.toString();
      if (this.auditForm.isValid == "true") {
      } else {
        if (!this.auditForm.description) {
          const h = that.$createElement;
          that.$notify({
            title: "",
            message: h("i", { style: "color: red" }, "请填写描述")
            // duration: 0
          });
          return false;
        }
        this.auditForm.description = this.auditForm.description.toString();
      }

      // this.auditForm.description=this.addInfo + this.auditForm.description;

      let data = this.auditForm;

      api.allegeAuditFiles(data).then(res => {
        if (!res.code) {
          that.$message({
            message: res.msg,
            type: "success"
          });
          that.appealDetailVisible = false;
          that.handleSearch();
        } else {
          that.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },

    //查看审核明细
    allegeDetail(id) {
      let that = this;
      this.auditForm.id = id;
      this.judgeFrom.id = id;
      this.appealDetailVisible = true;
      api.getAllegeDetailInfo(id).then(res => {
        if (!res.code) {
          that.ruleForm = res.data;
        }
      });
    },

    pageChange(e) {
      this.page = e;
      this.handleSearch();
    },
    sizeChange(e) {
      this.page = e;
      this.handleSearch();
    },

    //shousuo
    handleSearch() {
      let that = this;
      if (that.id) that.status = "";
      this.getOtcAllegeList({
        valid: that.valid,
        orderId: that.id,
        userId: that.userId,
        status: that.status,
        size: that.size,
        page: that.page
      });
      this.closAappealDialog();
    },

    handleClick(row) {
      let that = this;
      this.auditlVisible = true;
      this.auditForm.id = row.id;
    },

    //申诉
    allege(row, toFrom) {
      let that = this;
      let data = {
        id: row.id
      };
      api.allege(data, toFrom).then(res => {
        if (!res.code) {
          that.$message({
            message: res.msg,
            type: "success"
          });
          that.auditlVisible = false;
          that.handleSearch();
        } else {
          that.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  },

  mounted() {
    this.handleSearch();
  }
};
</script>

<style lang="less">
.complaint-page {

.applicationForm {
  fieldset{
    width: 100%;
    max-width: 506px;
    overflow: hidden;
  }
  .el-form-item{
    .el-form-item__content{
      .el-textarea{
        max-width: 500px;
        textarea{
          max-width: 500px;
          width: 100%;
        }

      }
    }
  }

  .descriptionBox {
    border: 1px solid #dcdfe6;
    width: 90%;
    min-height: 80px;
    padding: 5px 12px;
    line-height: 25px;
    font-size: 12px;

    text-align: justify;
    text-justify: newspaper;
    word-break: break-all;
  }
  .descriptionImgs {
    width: 555px;
    padding: 10px;
    display: flex;
    justify-content: flex-start;

    .imgs {
      width: 100px;
      margin-right: 28px;
      img {
        width: 100%;
        height: 100px;
        object-fit: cover;
      }
    }
  }

  .commintBox {
    width: 100%;
    .el-button {
      float: right;
    }
  }
}


  .el-textarea {
    width: 550px;
    min-height: 120px;
    .el-textarea__inner {
      min-height: 200px !important;
    }
  }
  .fenGeXian {
    width: 98%;
    height: 1px;
    background: #eaf0f2;
    clear: both;
    overflow: hidden;
    margin: 10px auto;
  }
  .actions-bar {
    width: 80%;
    display: flex;
    margin-bottom: 30px;
    .el-input {
      width: 300px;
      margin-right: 20px;
    }
    .searchBtn {
      margin-left: 15px;
    }

    .el-textarea__inner {
      width: 100% !important;
      min-height: 100px !important;
     background: orange;
      text-align: justify;
      text-justify: newspaper;
      word-break: break-all;
    }
  }

  .setImgBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .imgBox {
      width: 46%;
      height: auto;
      border: 1px dashed #c8cdd1;
      padding: 12px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      span {
        font-size: 14px;
        font-weight: bold;
      }
      img {
        width: 80%;
        float: right;
      }
    }
  }
}



</style>
